/* eslint-disable no-undef */
export default {
  SERVER_ENDPOINT: process.env.REACT_APP_SERVER_ENDPOINT,
};
